import DetailNotifyPartnerUser from 'page/Application/ManageProductAndService/TopPageProductPartnerUser/DetailNotifyPartnerUser';
import TopPageNotifyDetailPartnerUser from 'page/Application/ManageProductAndService/TopPageProductPartnerUser/TopPageNotifyDetailPartnerUser';
import TopPagePartnerUser from 'page/Application/ManageProductAndService/TopPageProductPartnerUser/TopPagePartnerUser';
import TopPageProductDetailPartnerUser from 'page/Application/ManageProductAndService/TopPageProductPartnerUser/TopPageProductDetailPartnerUser';
import TopPageProductSuperDetailPartnerUser from 'page/Application/ManageProductAndService/TopPageProductPartnerUser/TopPageProductSuperDetailPartnerUser';
import { Outlet } from 'react-router-dom';

const TopPageProductPartnerUser = () => {
  return <Outlet />;
};

export default TopPageProductPartnerUser;

export {
  DetailNotifyPartnerUser, TopPageNotifyDetailPartnerUser, TopPagePartnerUser, TopPageProductDetailPartnerUser,
  TopPageProductSuperDetailPartnerUser
};

